import { useEffect } from "react";

const useOutsideClick = (callBack, refs) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (refs && refs.length > 0 && !refs.some(ref => ref.current && ref.current.contains(event.target))) {
                callBack && callBack();
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, [refs]);
}

export default useOutsideClick;